import { Outlet } from "react-router-dom";

import Navigation from "../common/Navigation";
import Footer from "../common/Footer";

export default function Layout() {
  return (
    <>
      <Navigation />
      <Outlet />
      <Footer />
    </>
  );
}
